import { Component, ElementRef, ViewChild, AfterViewChecked } from '@angular/core';
import { SopAssistantService } from 'src/app/services/sop-assistant.service';

@Component({
  selector: 'app-sop-chat-panel',
  templateUrl: './sop-chat-panel.component.html',
  styleUrls: ['./sop-chat-panel.component.less']
})
export class SopChatPanelComponent implements AfterViewChecked {
  userInput = '';
  @ViewChild('messageList') private messageList: ElementRef;
  private shouldScroll = false;

  constructor(public sop: SopAssistantService) {}

  ngAfterViewChecked() {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  async send() {
    if (!this.userInput.trim()) return;
    const msg = this.userInput;
    this.userInput = '';
    this.shouldScroll = true;
    await this.sop.send(msg);
    this.shouldScroll = true;
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.send();
    }
  }

  close() {
    this.sop.close();
  }

  newChat() {
    const screeningId = this.sop.screeningId;
    this.sop.reset();
    this.sop.screeningId = screeningId;
  }

  private scrollToBottom() {
    if (this.messageList) {
      this.messageList.nativeElement.scrollTop = this.messageList.nativeElement.scrollHeight;
    }
  }
}
